export const ISSUE_CREATE_MODAL_MATCH = "/debts/:debt_id/issues/new"
